<template>
  <div class="newsList" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img class="tit_img" src="../../assets/images/index_icon1.png" alt="">
        </div>
        <div>首页>保函服务</div>
      </div>
    </div>
    <div class="new_box">
      <div class="cert_tit_box u-flex">
        <img src="../../assets/images/bhcx.png" alt="" />
        <div class="cert_line"></div>
      </div>

      <div class="search_box u-flex u-row-between">
        <div class="u-flex search_one">
          <div class="search_tit">查询分类</div>
          <div>
            <el-select class="inlineInput" v-model="status" placeholder="请选择" @change="changeStatus">
                <el-option label="全部" value=""></el-option>
                <el-option label="未支付" value="1"></el-option>
                <el-option label="已支付" value="3"></el-option>
                <el-option label="已完成" value="5"></el-option>
                <el-option label="驳回" value="-1"></el-option>
              </el-select>
          </div>
        </div>

        <el-button class="certbtn downLoadbtn" type="primary" @click="goPerson()">保函下载</el-button>
        
      </div>

      <div class="new_b_box" v-if="newlist&&newlist.length>0">
        <div class="new_s_box" v-for="(item,index) in newlist" :key="index">
          <div class="u-flex u-row-between">
            <div>
              <div class="news_introduce">
                项目名称：{{item.name}}  <br>
                保费：{{item.money}}元  <br>
                提交时间：{{item.createTime}} <br>
              </div>
            </div>
            <div>
              <div class="probtn_box">
                <el-button class="certbtn" type="primary" @click="newDetail(item.id)">查看状态</el-button>
              </div>
              <div class="probtn_box_sc">
                <el-button class="certbtn" type="primary" @click="deleteFun(item.id)">删除</el-button>
              </div>
              <!-- <div class="probtn_sc_txt">
               订单处理中...
              </div> -->
            </div>

          </div>
        </div>

      </div>
      <div class="nodata" v-if="!newlist||newlist.length==0">
              <img src="@/assets/images/nodata.png" alt="">
          </div>
      <div class="page_box">
            <el-pagination
              class="page_com"
              @current-change="logPage"
              :current-page.sync='currentpage'
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="count">
            </el-pagination>
          </div>
    </div>
  </div>
</template>

<script>
import  {sesStorage}  from '@/model/storage.js'
import  config  from '@/model/config.js'
import Qs from "qs";
export default {
  components: {},
  data() {
    return {
      newlist:[],
      pageSize:10,
      status:'',
      currentpage:1,
      baseurl:config.URL,
      fullscreenLoading:false,
      count:0
    };
  },
  methods: {
    changeStatus(){
      this.getorderList()
    },
    getorderList(){
      this.fullscreenLoading = true;
      let data = {
          page: this.currentpage,
          pageSize: this.pageSize,
          status: this.status,
          token: sesStorage.get('userObj').token,
        };
        this.$http
          .post("/front/order/orderList", Qs.stringify(data))
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == 0) {
              this.newlist=res.data.data;
              this.count=res.data.count;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
              if(res.data.code == 201){
                setTimeout(()=>{
                  this.$router.push({path:'/home/login'})
                },1000)
              }
            }
          });
    },
    newDetail(id){
      let data = {
        id: id,
        token: sesStorage.get('userObj').token,
      };
      this.$http
        .post("/front/order/seeOrder", Qs.stringify(data))
        .then((res) => {
          if (res.data.code == 0) {
            this.$router.push({
              path:'/home/Detail',
              query:{
                obj:res.data.data.project	,
                id: id,
                hasOrder:true,
                status:res.data.data.status,
                dbType:res.data.data.dbType
              }
            })
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              center: true,
            });
            if(res.data.code == 201){
              setTimeout(()=>{
                this.$router.push({path:'/home/login'})
              },1000)
            }
            if(res.data.code == 301){
              setTimeout(()=>{
                this.$router.push({path:'/home/certification'})
              },1000)
            }
          }
        })
      
    },
    deleteFun(id){
      this.$confirm('此操作将删除该保函, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        let data = {
          id:id,
          token: sesStorage.get('userObj').token,
        };
        this.$http
          .post("/front/order/removeOrder", Qs.stringify(data))
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getorderList()
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
              if(res.data.code == 201){
                setTimeout(()=>{
                  this.$router.push({path:'/home/login'})
                },1000)
              }
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    logPage(val) {
      this.currentpage=val;
      this.getorderList()
    },
    goPerson(){
      this.$router.push({path:'/home/personal',query:{activeIndex:'2'}})
    }
  },
  mounted() {
    this.getorderList()
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.newsList {
  background: #edf1f5;
  overflow: hidden;

   .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img{
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
  
  .newsbanner {
    width: 1920px;
    margin: 0 auto;
    display: block;
  }
  .new_box {
    width: 1500px;
    margin: 0 auto 40px auto;
    overflow: hidden;
    margin-top: 20px;
    padding: 38px 35px 10px 35px;
    position: relative;
    background: #fff;
    .inlineInput {
      & >>> .el-input__inner{
        width: 400px;
        background: #F9FAFE;
        border: 1px solid #303643;
        border-radius: 2px;
      }
    }
    .inlineSelect{
      & >>> .el-input__inner{
        width: 200px;
        background: #F9FAFE;
        border: 1px solid #303643;
        border-radius: 2px;
      }
      margin-right: 8px;
    }
    .cert_tit_box {
      .cert_line {
        width: 100%;
        height: 1px;
        background-color: #303643;
        margin-left: 14px;
      }
    }
    .achtabs {
      & >>> .el-tabs__header {
        margin: 0 0 5px;
      }
      & >>> .el-tabs__nav-wrap::after {
        height: 1px;
      }
      & >>> .el-tabs__content {
        overflow: initial;
      }
    }

    & >>> .el-tabs__item {
      padding: 0 20px;
      color: #999999;
      height: 50px;
      line-height: 50px;
    }
    & >>> .el-tabs__active-bar {
      background: #19539a;
    }
    & >>> .el-tabs__item.is-active {
      color: #19539a;
    }
  }
  .new_b_box {
    margin-top: 30px;
    .new_s_box {
      margin-bottom: 36px;
      background-color: #F5F6FA;
      padding: 24px 58px 24px 34px;
      .img_new{
       width: 300px;
      height: 200px;
      display: inline-block;
      background: #ccc;
    }
      .news_introduce {
       font-size: 14px;
       line-height: 28px;
      }
    }
  }

  .page_box {
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: center;
    .page_com {
      display: inline-block;
    }
    &>>>.el-pager li.active {
        color: #19539a;
    }
    &>>>.el-pager li:hover {
        color: #19539a;
    }
    
  }
  .nodata{
    text-align: center;
    padding: 40px 0 20px 0;
  }

  .search_box{
    padding: 20px 20px 20px 0;
    margin-top: 20px;
    background-color: #EDEEF2;
    .search_tit{
      font-size: 14px;
      font-weight: bold;
      margin-right: 28px;
    }
    .search_one{
      margin-left: 34px;
    }
    .search_two{
      margin-left: 50px;
    }
  }
  .certbtn_box {
    width: 80px;
    margin-left: 90px;
  }
  .probtn_box {
    width: 110px;
  }
  .probtn_box_sc{
    width: 110px;
    margin-top: 14px;
  }
  .probtn_sc_txt{
    width: 110px;
    margin-top: 14px;
    font-size: 14px;
    text-align: center;
    color: #999999;
  }
  .certbtn {
    height: 40px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 100%;
  }
  .downLoadbtn{
    width: 140px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/query/queryList.vue